import { createAsyncThunk } from "@reduxjs/toolkit";
import PropertyService from "~/services/PropertyService";

export const getProperties = createAsyncThunk("property/fetch", async () => {
  const res = await PropertyService.getList({ num: 5 });
  return res?.data;
});
